import React from "react";
import { TextInputV2 } from "@boi/react-components";

import Container from "./container";
import { iControlProps } from "../types";

type AccountNumberProps = iControlProps & {
    error?: string;
    placeholder? : string;
    id? : string;
};

const AccountNumber = ({ onChange, ...props }: AccountNumberProps) => {
    return (
        <Container {...props}>
            <TextInputV2
                inputMode="numeric"
                value={props.value}
                placeholder={props.placeholder || ""}
                onChange={(newValue: string) => {
                    onChange && onChange(newValue);
                }}
                onBlur={(e) => {
                    onChange && onChange(e.target.value);
                }}
                type="text"
                id={props.id}
                // remove this aria-label if the Container component has deleted and the label and other props are passed to TextInputV2
                aria-label={props.label}
                isRequired={props.isRequired}
                isInvalid={!!props.error}
            />
        </Container>
    );
};

export default AccountNumber;
